import { defineStore } from 'pinia'
import { ref } from 'vue'
import { SettingsService } from '@/services/settingsService'

export const useSettingsStore = defineStore('settings', () => {
  // State
  const allowMultiShopBasket = ref(false)
  const loaded = ref(false)

  // Actions
  async function fetchSettings() {
    if (loaded.value) return
    try {
      const settings = await SettingsService.getPublicSettings()
      allowMultiShopBasket.value = settings.allowMultiShopBasket
      loaded.value = true
    } catch (error) {
      console.error('Failed to fetch settings:', error)
    }
  }

  return {
    allowMultiShopBasket,
    loaded,
    fetchSettings
  }
})
